<template>
    <h2 class="clienti clientivmargin">{{ customers }}</h2>
    <img class="clienti clientivmarginsmall" src="@/assets/images/clienti.png"/>
    
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

// eslint-disable-next-line no-unused-vars

export default {
  name: "cmpcustomers",
  mixins:[multilangmixin],
    

  data(){
      return {

            };
  },

  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

  },

  computed:{
  
      customers(){
          return this.fnGetTranslation(this.currentlang,"customers");
      },
       

  },


  methods:{


  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    





.clientivmargin{
  margin-top: 50px;

}

.clientivmarginsmall{
  margin-top: 20px;

}



  @media screen and (min-width: 700px)    {
      /*  schermo desktop */
    
 

      .clienti{
          margin-left: auto;
          margin-right: auto;
          display: block;
          text-align: center;
          font-size: 1.3em;
          font-weight: bold;
      }

  }
  
  @media screen and (max-width: 700px) {
     /*  schermo mobile */
  
 

    .clienti{
      margin-left: auto;
      margin-right: auto;
      width: 95%;
      display: block;
      text-align: center;
      font-size: 1.4em;
      font-weight: bold;
    }
  }


</style>
